module.exports = __webpack_public_path__ + "img/credit-card.fb9852fa.svg";